export default String.raw`
.newsletterPopup {
    background-color: transparent !important;
    width: fit-content !important;
    margin: auto !important;
    
    &__body {
        width: 652px;
        min-height: 320px;
        max-height: 80%;
        background-color: $newsletterBgColor;
        border-radius: 12px;
        padding: 32px 24px;
    }

    &__header {
        display: flex;
        justify-content: space-between;

        svg {
            width: 24px;
            height: 24px;
            fill: $bgColorFont;
            cursor: pointer;
        }
    }

    &__content {
        display: flex;
        justify-content: space-between;
        padding-top: 24px;

        &-left {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 185px;

            div {
                display: flex;
                align-items: center;
                column-gap: 16px;
                svg {
                    width: 32px;
                    height: 32px;
                    fill: $newsletterFont;
                }

                span {
                    @include body-1-medium;
                    color: $newsletterFont;
                }
            }
        }

        &-right {
            display: flex;
            flex-direction: column;
            row-gap: 16px;
            width: 326px;
            height: 100%;

            p {
                @include body-1-regular;
                color: $newsletterFont;
            }

            &-email {
                display: flex;
                align-items: center;
                position: relative;
                width: 100%;

                svg {
                    position: absolute;
                    width: 24px;
                    height: 24px;
                    fill: $bgColorFont;
                    left: 16px;
                }

                input {
                    width: 100%;
                    height: 40px;
                    padding: 0px 8px 0 48px;
                    background-color: $inputsBgColor;
                    border: 1px solid $bgColorFont;
                    border-radius: 5px;
                    @include body-1-regular;
                    color: $newsletterFont;
                }
            }

            &-buttons {
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                gap: 16px;

                button {
                    min-width: 100%;
                    max-width: 100%;
                }

                p, span {
                    @include body-2-regular;
                    color: $newsletterFont;
                    
                    a {
                        text-decoration: underline;
                        cursor: pointer;
                    }
                }

                svg {
                    position: relative;
                    top: 5px;
                }
            }
        }
    }
}
`